import { CubeTransparent } from '@/components/ui/customIcons/cubeTransparent';
import { WhoDidWhatWhen } from './whoDidWhatWhen/whoDidWhatWhen';
import { References } from '../references/references';
import { count } from '@/components/traceInspector/traceInspector.utils';
import { useEffect, useState } from 'react';
import { LinkQueryResult } from '../traceInspector.types';
import { SegmentBody } from './segmentBody';
import { SegmentEvidence } from './segmentEvidence';

type Props = {
  traceId: string;
  link: LinkQueryResult;
  linkCreatedByAccount: object;
  workflowContext: object;
};

export const SegmentDetail = ({
  traceId,
  link,
  linkCreatedByAccount,
  workflowContext
}: Props) => {
  const [evidencesHidden, setEvidencesHidden] = useState<boolean>(true);
  const [referencesHidden, setReferencesHidden] = useState<boolean>(true);

  const onEvidenceClick = () => {
    setEvidencesHidden(prevState => !prevState);
  };

  const handleReferencesClick = () => {
    setReferencesHidden(prevState => !prevState);
  };

  useEffect(() => {
    setReferencesHidden(true);
  }, [link.height]);

  return (
    <div className="text-card-foreground">
      <div className="mb-1 flex w-full items-center gap-4">
        <div className="flex grow items-center gap-4">
          <div className="text-lg font-semibold">
            {link.action?.title ?? null}
          </div>
          <div className="bg-primary-deep/5 border-primary-deep/10 text-primary-deep flex h-5 items-center rounded-lg px-3 py-1 text-xs whitespace-nowrap select-none">
            Action {count(link.height)}
          </div>
        </div>
        <div
          onClick={onEvidenceClick}
          aria-expanded={!evidencesHidden}
          className="group/evidenceButton text-muted-foreground hover:text-primary flex cursor-pointer items-center gap-2 select-none hover:underline"
        >
          <CubeTransparent className="text-primary size-4" />
          <p className="hidden cursor-pointer text-xs lg:flex">{`${
            evidencesHidden ? 'Show' : 'Hide'
          } blockchain info`}</p>
        </div>
      </div>
      <div className="flex flex-col gap-4">
        <WhoDidWhatWhen link={link} />
        {!evidencesHidden && (
          <div
            className="mb-6 h-fit overflow-hidden opacity-100 transition-all duration-300 starting:h-0 starting:opacity-0"
            aria-hidden={evidencesHidden}
          >
            <SegmentEvidence link={link} />
          </div>
        )}
        <References
          link={link}
          traceId={traceId}
          collapsed={referencesHidden}
          handleClick={handleReferencesClick}
        />
        <section className="mt-2">
          <SegmentBody
            link={link}
            linkCreatedByAccount={linkCreatedByAccount}
            traceId={traceId}
            workflowContext={workflowContext}
          />
        </section>
      </div>
    </div>
  );
};
